var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useAllRates } from "../utils/hooks/rates/useRates";
var PickRateDialog = function (props) {
    var t = useTranslation().t;
    var _a = useState(null), rate = _a[0], setRate = _a[1];
    var allRates = useAllRates();
    useEffect(function () {
        if (props.open) {
            setRate(null);
        }
    }, [props.open]);
    return (_jsxs(Dialog, __assign({ open: props.open, onClose: props.onClose }, { children: [_jsx(DialogTitle, { children: t('Pick an existing rate') }), _jsx(DialogContent, __assign({ sx: { '&&': { pt: 1 } } }, { children: _jsx(Autocomplete
                // disablePortal
                , { 
                    // disablePortal
                    id: "parent-resource", options: allRates, fullWidth: true, getOptionLabel: function (option) { return option.name || ''; }, value: rate, renderInput: function (params) { return _jsx(TextField, __assign({}, params, { size: 'small' })); }, onChange: function (e, value) {
                        setRate(value);
                    }, sx: { width: 400 } }) })), _jsx(DialogActions, { children: _jsx(Button, __assign({ variant: 'contained', color: 'primary', onClick: function () {
                        rate && props.onConfirm(rate);
                    }, startIcon: _jsx(SaveIcon, {}), disabled: !(rate === null || rate === void 0 ? void 0 : rate.id) }, { children: t("Save") })) })] })));
};
export default PickRateDialog;
